const showPopper = function showPopperCallback(popper, data) {
  return function showPopperEvent(e) {
    popper.show(e.currentTarget, data);
  };
};

const togglePopper = function togglePopperCallback(popper, data) {
  return function togglePopperEvent(e) {
    popper.toggle(e.currentTarget, data);
  };
};

const hidePopper = function hidePopperCallback(popper) {
  return function hidePopperEvent(e) {
    if (e.relatedTarget !== popper.$el) popper.hide();
  };
};

const getReference = (el, binding, vnode) => {
  const popper = vnode.context.$refs[binding.arg];
  if (popper) {
    if (binding.modifiers.hover) {
      popper.$on('show', () => {
        el.addEventListener('mouseleave', hidePopper(popper));

        popper.$el.addEventListener('mouseleave', (e) => {
          if (e.relatedTarget !== el) popper.hide();
        });
      });

      el.addEventListener('mouseover', showPopper(popper, binding.value));
    } else {
      el.addEventListener('click', togglePopper(popper, binding.value));
    }
  }
};

export default {
  inserted(el, binding, vnode) {
    getReference(el, binding, vnode);
  },

  unbind(el, binding, vnode) {
    const popper = vnode.context.$refs[binding.arg];

    if (popper) {
      el.removeEventListener('click', togglePopper);
      el.removeEventListener('mouseover', showPopper);
      el.removeEventListener('mouseleave', hidePopper);

      if (popper.popper && popper.popper.reference && popper.popper.reference === el) {
        popper.hide();
      }
    }
  },
};
